import { useEffect } from "react";

export default function useExtensionAuthUpdate() {
  useEffect(() => {
    window.postMessage({ action: "extension.auth.update" });
  }, []);

  return null;
}
